import React, { useState } from "react";
import "./styles.css";
//import { AiOutlineSearch } from "react-icons/ai";
import { IoIosArrowDown } from "react-icons/io";
import { Collapse } from "react-collapse";
//import { NavLink } from "react-router-dom";
import SideNav from './../../../components/SideNav_RI';
import ListPendingExam from "../../../components/Display_RepresentanteDeInstituição/Listar_Consultas/Pendentes";
import ListConfermedExam from "../../../components/Display_RepresentanteDeInstituição/Listar_Consultas/Agendadas";
import ListPastExam from "../../../components/Display_RepresentanteDeInstituição/Listar_Consultas/Passadas";


export default function RI_Consulta() {
    //let [search, setSearch] = useState(false);
    let [agendada, setAgendada] = useState(false);
    let [confirmadas, setConfirmada] = useState(false);
    let [passadas, setPassadas] = useState(false);
    return (
        <>
            <SideNav />
             <div id="top-RI-Cadastro"></div>
            <div id="main-RI-Consulta">
                <p id="RI-Consulta">Lista de consultas pendentes</p>
                <hr  id="divider-RI-Consulta" />
                <div id="arrow-RI-Consulta">
                    <IoIosArrowDown
                        onClick={() =>
                            setAgendada(!agendada)
                        }
                        size={"6vh"}
                        id="IconDown-RI-Consulta"
                    />
                </div>
                <Collapse isOpened={agendada}>
                    <div id="collapsed-RI-Consulta">                        
                        <ListPendingExam/>
                    </div>
                </Collapse>

                <p id="RI-Consulta">Lista de consultas confirmadas</p>
                <hr  id="divider-RI-Consulta" />
                <div id="arrow-RI-Consulta">
                    <IoIosArrowDown
                        onClick={() =>
                            setConfirmada(!confirmadas)
                        }
                        size={"6vh"}
                        id="IconDown-RI-Consulta"
                    />
                </div>
                <Collapse isOpened={confirmadas}>
                    <div id="collapsed-RI-Consulta">                        
                        <ListConfermedExam />
                    </div>
                </Collapse>
                
                <p id="RI-Consulta">Lista de consultas passadas</p>
                <hr id="divider-RI-Consulta" />
                <div id="arrow-RI-Consulta">
                    <IoIosArrowDown
                        onClick={() =>
                            setPassadas(!passadas)
                        }
                        size={"6vh"}
                        id="IconDown-RI-Consulta"
                    />
                </div>
                <Collapse isOpened={passadas}>
                    <div id="collapsed-RI-Consulta">                    
                        <ListPastExam />
                    </div>
                </Collapse>
            </div>
        </>
    );
}